import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ModuleReducer(state = initialState.module, action: any) {
  switch (action.type) {
    case types.SAVE_MODULE_SUCCESS:
      return action.module;
    default:
      return state;
  }
}
